/**
 * Form label-preset helpers.
 *
 * Canonical preset for the split-caption InputField chrome is `splitCaption`.
 */

export type LabelPreset = 'splitCaption' | 'journalSection'

/**
 * Normalize a raw labelPreset from config/JSON to the canonical name.
 * Unknown values → undefined (fail-open: treat as no preset).
 */
export function normalizeLabelPreset(
  raw: string | undefined | null,
): LabelPreset | undefined {
  if (!raw) return undefined
  if (raw === 'splitCaption' || raw === 'journalSection') return raw
  return undefined
}

export function isSplitCaptionPreset(raw: string | undefined | null): boolean {
  return normalizeLabelPreset(raw) === 'splitCaption'
}
